<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">Social and other links</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Google page</mat-label>
      <input [(ngModel)]="google_business_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Google review page link</mat-label>
      <input [(ngModel)]="google_business_review_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Facebook page</mat-label>
      <input [(ngModel)]="facebook_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Facebook review page link</mat-label>
      <input [(ngModel)]="facebook_review_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Instagram page</mat-label>
      <input [(ngModel)]="instagram_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business X (Twitter) page</mat-label>
      <input [(ngModel)]="twitter_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Linkedin page</mat-label>
      <input [(ngModel)]="linkedin_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Youtube page</mat-label>
      <input [(ngModel)]="youtube_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Playstore page</mat-label>
      <input [(ngModel)]="google_play_store_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business Appstore page</mat-label>
      <input [(ngModel)]="apple_app_store_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business privacy policy page</mat-label>
      <input [(ngModel)]="privacy_policy_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business terms of services page</mat-label>
      <input [(ngModel)]="terms_of_services_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business refund policy page</mat-label>
      <input [(ngModel)]="refund_policy_url" matInput type="text" />
    </mat-form-field>
  </div>
  <div class="conversion-row">
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Business cookie policy page</mat-label>
      <input [(ngModel)]="cookie_policy_url" matInput type="text" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" >
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="accent" (click)="onsave()" >Save</button>
</mat-dialog-actions>
